const partnerConstants = {
	PLANALTO: 'planalto',
	MOVEFLEX_STORE: 'loja-muviflex',
	// LIVELO: 'livelo'
}

export default partnerConstants
